import type { DiagramLabelPosition, DiagramNodeData, DiagramLinkData } from './diagram.types';
import { DiagramLabel } from './DiagramLabel';
import type { TextDimensions } from '../hooks/PRIVATE_useTextDimensions';
import { layerStyles } from './themes/DiagramStyles.css';
import { useUser } from '../hooks/UNSAFE_useUser';

type Props<K1, K2, D1, D2> = {
  labelPosition: (DiagramLabelPosition | undefined)[];
  itemProps: (D1 | D2)[];
  labelDimensions: Map<K1 | K2, TextDimensions>;
};

export function DiagramLabelLayer<
  K1,
  K2,
  D1 extends DiagramNodeData<K1>,
  D2 extends DiagramLinkData<K2, K1>
>({ labelPosition, itemProps, labelDimensions }: Props<K1, K2, D1, D2>) {
  const { direction } = useUser();
  return (
    <div class={layerStyles}>
      {itemProps.map((item, i) => {
        if (item.label && labelPosition[i]) {
          return (
            <DiagramLabel
              styles={item.labelStyle}
              text={item.label}
              position={labelPosition[i]!}
              dimensions={labelDimensions.get(item.id)!}
              isRTL={direction === 'rtl'}
            />
          );
        }
        return undefined;
      })}
    </div>
  );
}
